export type StyleMixins = {
  adHeight: string
  adWidth: string
}

//Give extra hight on actual return
export const styleMixins: Record<string, StyleMixins> = {
  // NTP 300x250 AD (room for slug)
  304_300: {
    adHeight: '304px',
    adWidth: '300px',
  },
  304_612: {
    adHeight: '304px',
    adWidth: '612px',
  },
  610_300: {
    adHeight: '610px',
    adWidth: '300px',
  },
  auto: {
    adHeight: 'auto',
    adWidth: 'auto',
  },
  '400_FULL': {
    adHeight: '400px',
    adWidth: 'auto',
  },
  '310_FULL': {
    adHeight: '266px',
    adWidth: '100%',
  },
  100_300: {
    adHeight: '100px',
    adWidth: '300px',
  },

  290_340: {
    adHeight: '290px',
    adWidth: '340px',
  },
  '250_970': {
    adHeight: '250px',
    adWidth: '970px',
  },
}
